import styled from "styled-components";
import Image from "next/image";
import nftRecord from "../../../../../public/images/nft-record.png";

const Container = styled.div`
  position: relative;
  max-width: 365px;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobileL}) {
    max-width: 295px;
  }
`;

const NftIcon = styled(Image)`
  filter: drop-shadow(0px 10px 30px rgba(0, 0, 0, 0.5));
`;

const NftRecordIcon = () => {
  return (
    <Container>
      <NftIcon alt="nft record" src={nftRecord} />
    </Container>
  );
};

export default NftRecordIcon;
